function burgerMenu() {
 let burgerMenu = document.querySelector('.burger-menu');
 let header = document.querySelector('.header');
 let mediaQuery = window.matchMedia('(min-width: 320px) and (max-width: 1250px)');
 let headerMenu = header.querySelector('.menu');
 let headerArrow = headerMenu.querySelectorAll('.arrow');
 let subMenu = headerMenu.querySelectorAll('.sub-menu');
 if (burgerMenu || header) {
  burgerMenu.addEventListener('click', function (e) {
   e.preventDefault();
   burgerMenu.classList.toggle('active');
   header.classList.toggle('active');
   document.body.classList.toggle('no-scroll')
  })
 }

 if (mediaQuery.matches) {
  for (let m = 0; m < headerArrow.length; m++) {
   headerArrow[m].addEventListener('click', function(e) {
    e.preventDefault();
    headerArrow[m].classList.toggle('active');
    subMenu[m].classList.toggle('active');
   })
  }
 }
}
burgerMenu()